const SEM_USER_COOKIE_NAME = 'PPCUser';
const SEM_USER_COOKIE_VALUE = '1';
const SEM_USER_QUERY_NAME = 'cfsource';
const SEM_USER_QUERY_VALUE = 'sem';
const MT_USER_QUERY_NAME = 'customnative6';
const MT_USER_S7_COOKIE_NAME = 'MTUSER_S7';
const SWIMLANE_COOKIE_NAME = 'cf_trk_swimlane';
const NUMBER_OF_SWIMLANES = 4;
const SWIMLANE_EXPIRATION_DAYS = 30;

export function getS17Value()
{
    return getCustomField1Value();
}

export function getCustomField1Value()
{
    var fieldValue =  document.body.querySelector('#customfield1')?.value || 'pagetype-unknown';
	return fieldValue;
}

/**
 * Determine whether the current user is an SEM user or not.
 * @returns {boolean} - if the user is an SEM user or not
 */
export function isSemUser()
{
    return (getCookie(SEM_USER_COOKIE_NAME) === SEM_USER_COOKIE_VALUE) ||
        (getQSValue(SEM_USER_QUERY_NAME) === SEM_USER_QUERY_VALUE);
}

/**
 * Determine whether the current user is a Media Transformation user or not.
 * @returns {boolean} - if the user is a MT user or not
 */
export function isMTUser()
{
    let $queryParamValue = getQSValue(MT_USER_QUERY_NAME);
    let $cookieValue = getCookie(MT_USER_S7_COOKIE_NAME);

    if (!isCrawler() && ($queryParamValue || $cookieValue)
    ) {
        // Update cookie if query param is set
        if ($queryParamValue && $queryParamValue !== $cookieValue) {
            setCookie(MT_USER_S7_COOKIE_NAME, $queryParamValue);
        }

        return true;
    } else {
        return false;
    }
}

/**
 * Fetch the swimlane cookie and return the swimlane id as an integer.
 * @returns {null|number} - the swimlane id, or null if there is no cookie, or the cookie is set to an invalid value
 */
export function getSwimlane()
{
    const swimlaneCookie = getCookie(SWIMLANE_COOKIE_NAME);
    if (swimlaneCookie.length > 0) {
        const swimlane = parseInt(swimlaneCookie, 10);
        if (!isNaN(swimlane) && swimlane > 0 && swimlane <= NUMBER_OF_SWIMLANES) {
            return swimlane;
        } else {
            return null;
        }
    }

    return null;
}

/**
 * Set the swimlane for the current user.
 * If the user already has a swimlane, this function will do nothing.
 * So it is safe to call in any circumstance.
 */
export function assignSwimlaneToUser()
{
    if (getSwimlane() === null) {
        // assign a new swimlane!
        const swimlane = 1 + Math.floor(Math.random() * NUMBER_OF_SWIMLANES);

        // swimlane lasts 24 hours
        const expiration = new Date();
        expiration.setTime(expiration.getTime() + (SWIMLANE_EXPIRATION_DAYS * 24 * 60 * 60 * 1000));

        console.log('swimlane');

        document.cookie = `${SWIMLANE_COOKIE_NAME}=${swimlane};path=/;expires=${expiration.toUTCString()}`;
    }
}

export function setCookie(cname, cvalue, cdays = 14)
{
    const d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000 * cdays)); // 14 days
    let expires = 'expires='+ d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

/**
 * Read a cookie
 * @param {string} cname - cookie name
 * @returns {string|""} - cookie value, or empty string if cookie is not set
 */
export function getCookie(cname)
{
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

/**
 * Read query parameter from current URL
 * @param key - which parameter to read
 * @returns {string} - parameter value
 */
export function getQSValue(key)
{
    return decodeURIComponent(
        window.location.search.replace(
            new RegExp(
                '^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[.+*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$',
                'i'
            ),
            '$1'
        )
    );
}

/**
 * Determine whether the current user agent is a crawler.
 * @returns {boolean} - true the user agent is a crawler, false if not
 */
function isCrawler()
{
    const userAgent = navigator.userAgent? navigator.userAgent.toLocaleLowerCase() : '';
    const patternt = '/Googlebot|Mediapartners-Google|AdsBot-Google|googleweblight|Storebot-Google|Google-PageRenderer|Bingbot|BingPreview|Slurp|DuckDuckBot|baiduspider|yandex|sogou|LinkedInBot|bitlybot|tumblr|vkShare|quora link preview|facebookexternalhit|facebookcatalog|Twitterbot|applebot|redditbot|Slackbot|Discordbot|WhatsApp|SkypeUriPreview|ia_archiver/'.toLocaleLowerCase();
    const regex = new RegExp(patternt, 'i');

    if (userAgent !== '') {
        if (regex.test(userAgent)) {
            return true;
        } else {
            return false;
        }
    }

    return false;
}

function swapRP()
{
    if (getCookie('PPCUser') === '1' || getQSValue('cfsource') === 'sem') {
        //SEM User
        //console.log("SEM User");
        replaceRP(window.rp_sem, window.rp_seo);
    } else {
        //SEO User
        //console.log("SEO User");
        replaceRP(window.rp_seo, window.rp_sem);
    }
}

function replaceRP(arr, rep)
{
    for (var i = 0; i < rep.length; i++) {
        if (arr[i].dnis !== '') {
            var matches = document.querySelectorAll('span[ringpoolid="' + rep[i].rpid + '"]', 'a[ringpoolid="' + rep[i].rpid + '"]');
            matches.forEach(function (item) {
                item.setAttribute('ringpoolid', arr[i].rpid);
                item.setAttribute('placeholder', arr[i].dnis);
                window.atags = item.getElementsByTagName('a');
                for (var j = 0; j < window.atags.length; j++) {
                    window.atags[j].setAttribute('href', 'tel:' + arr[i].dnis);
                    window.rptext = window.atags[j].innerHTML.replace(/\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})/, arr[i].dnis);
                    window.atags[j].innerHTML = window.rptext;
                }
            });
        }
    }
    reloadRP();
}

function reloadRP()
{
    if (window.cl_object && typeof window.cl_object.runner === 'function') {
        window.cl_object.runner();
        console.log('Rerun Ringpool');
    } else {
        setTimeout(reloadRP, 500);
    }
}
export default function init()
{
    swapRP();
}
